import { frontendURL } from '../../../helper/URLHelper';
import KontaCompaniesIndex from './pages/KontaCompaniesIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/konta-companies'),
    component: KontaCompaniesIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'konta_companies_dashboard_index',
        component: KontaCompaniesIndex,
        meta: commonMeta,
      },
    ],
  },
];
